import { useState, useEffect } from 'react';
import GeneratorModal from '@/components/analyticsPage/tabPanels/components/initiateCTA/components/generatorModal';
import TutorialModal from '@/components/analyticsPage/tabPanels/components/initiateCTA/components/tutorialModal';
import DataDrawer from '@/components/analyticsPage/tabPanels/components/drawers/dataDrawer';
import IndexDrawer from '@/components/analyticsPage/tabPanels/components/drawers/indexDrawer';
import { useSelector } from 'react-redux';
import {
  useResetAllDataDrawer,
  useResetAllIndexDrawer,
  useResetDataFilters,
  useResetIndexFilters,
} from '@/components/analyticsPage/tabPanels/components/initiateCTA/hooks/useResetDrawer';
import { useInitDrawer } from './hooks/useInitDrawer';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { PlusIcon } from 'lucide-react';

const InitiateCTA = () => {
  const [t] = useTranslation('analytics');

  const [openGeneratorModal, setOpenGeneratorModal] = useState(true);
  const [openTutorialModal, setOpenTutorialModal] = useState(false);
  const [openDataDrawer, setOpenDataDrawer] = useState(false);
  const [openIndexDrawer, setOpenIndexDrawer] = useState(false);
  const { dataQuery, indexQuery } = useSelector((state: any) => state.analytics);
  const [resetAllDataDrawer] = useResetAllDataDrawer();
  const [resetAllIndexDrawer] = useResetAllIndexDrawer();
  const [resetDataFilters] = useResetDataFilters();
  const [resetIndexFilters] = useResetIndexFilters();
  const location = useLocation();
  const [updateDrawer] = useInitDrawer();

  useEffect(() => {
    if (location?.state?.companyId) {
      resetDataFilters();
      resetIndexFilters();
      updateDrawer();
    } else {
      resetAllDataDrawer();
      resetAllIndexDrawer();
    }
  }, [openDataDrawer, openIndexDrawer]);

  return (
    <div>
      <div className="flex flex-col items-center justify-center h-[60vh] space-y-4 border-2 border-primary rounded-lg p-4 my-4">
        <div className="text-2xl font-bold">{t('Create customized data')}</div>
        <Button onClick={() => setOpenGeneratorModal(true)} className="w-[300px]">
          <PlusIcon className="w-4 h-4" />
          {t('Create')}
        </Button>
      </div>
      <GeneratorModal
        open={openGeneratorModal}
        closeModal={() => setOpenGeneratorModal(false)}
        handleDataDrawer={() => setOpenDataDrawer(true)}
        handleIndexDrawer={() => setOpenIndexDrawer(true)}
      />
      <TutorialModal open={openTutorialModal} closeModal={() => setOpenTutorialModal(false)} />
      <DataDrawer
        open={openDataDrawer}
        data={dataQuery}
        action="create"
        closeDrawer={() => setOpenDataDrawer(false)}
      />
      <IndexDrawer
        open={openIndexDrawer}
        data={indexQuery}
        action="create"
        closeDrawer={() => setOpenIndexDrawer(false)}
      />
    </div>
  );
};

export default InitiateCTA;
